import { ConversationEmbed } from '@thoughtspot/visual-embed-sdk/lib/src/react'

import PageContainer from 'common/components/PageContainer'

import { EMBED_CLASS_NAME } from './styles'

export const Jaqi = () => {
  const THOUGHTSPOT_SPOTTER_WORKSHEET_ID =
    process.env.REACT_APP_THOUGHTSPOT_SPOTTER_WORKSHEET_ID

  if (!THOUGHTSPOT_SPOTTER_WORKSHEET_ID) {
    throw new Error(
      'THOUGHTSPOT_SPOTTER_WORKSHEET_ID is missing in the .env file'
    )
  }

  return (
    <PageContainer>
      <ConversationEmbed
        dataPanelV2
        className={EMBED_CLASS_NAME}
        worksheetId={THOUGHTSPOT_SPOTTER_WORKSHEET_ID}
      />
    </PageContainer>
  )
}
